import React from "react";

const EditButton = ({ onExpand, record }) => {
  const handleEdit = (e) => {
    onExpand(record, e);
  };
  return (
    <span onClick={handleEdit} className="reporting-edit-button">
      Edit
    </span>
  );
};

export default EditButton;
